module.exports = __webpack_public_path__ + "img/bg-4.96e2c497.jpg";